<template>
  <div class="service-pagination d-flex justify-content-center my-4">
    <b-pagination-nav
      v-if="numberOfPages > 0"
      v-model="cPage"
      :number-of-pages="numberOfPages"
      :link-gen="linkGen"
      base-url="#"
      last-number
      use-router
      center
      pills
    ></b-pagination-nav>
  </div>
</template>

<script>
import store from '@/store/'
import { mapGetters } from 'vuex'
import { FETCH_SERVICES } from '@/store/actions.type.js'

export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      pages1: ['?page=1', '?page=2', '?page=3'],
    }
  },
  computed: {
    pages2() {
      let pages = []
      if (this.services) {
        for (let index = 0; index < this.services.totalPages; index++) {
          pages.push('?page=' + (index + 1))
        }
      }
      return pages
    },
    cPage: {
      get() {
        return this.currentPage
      },
      set(val) {
        return val
      },
    },
    numberOfPages() {
      if (this.services) {
        return this.services.totalPages
      }
      return 0
    },
    ...mapGetters(['services']),
  },
  watch: {
    currentPage: {
      handler: function () {
        store.dispatch(FETCH_SERVICES, this.$route.query)
      },
    },
  },
  methods: {
    linkGen(pageNum) {
      let query = Object.assign({}, this.$route.query)
      query.page = parseInt(pageNum)
      if (query.include) delete query.include
      return {
        path: this.$route.path,
        query: query,
      }
    },
  },
}
</script>
